import React from 'react';
import { Modal } from 'react-bootstrap';
import styles from './style.css';
import OtpInput from '../../Register/OtpInput/OtpInput';

class OtpModalDialog extends React.Component {
  render() {
    const {
      onShow,
      onHide,
      phone,
      otpError,
      setOtpError,
      handleOtpAction,
      handleResendOtp,
      handleOtpSubmit,
    } = this.props;
    return (
      <Modal className={styles['modal-otp']} show={onShow}>
        <OtpInput
          timer={onShow}
          phone={phone}
          otpError={otpError}
          className="modal-full-width"
          setOtpError={setOtpError}
          showOtpAction={handleOtpAction}
          handleResendOtp={handleResendOtp}
          handleBackClick={onHide}
          handleOtpSubmit={handleOtpSubmit}
        />
      </Modal>
    );
  }
}

export default OtpModalDialog;
